<template>
  <transition
    name="expand"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <slot />
  </transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "TransitionExpand",
  props: {
    duration: {
      type: String,
      default: null,
      description: "The duration of the transition."
    }
  },
  methods: {
    beforeEnter: function (element) {
      if (!element.style.height) {
        element.style.height = "0px";
      }

      element.style.display = null;
      if (this.duration) {
        element.style["transition-duration"] = this.duration;
      }
    },

    enter: function (element) {
      element.style.height = `${element.scrollHeight}px`;
    },

    afterEnter: function (element) {
      element.style.height = null;
      if (this.duration) {
        element.style["transition-duration"] = null;
      }
      this.$emit("ui-expand-enter");
    },

    beforeLeave: function (element) {
      if (!element.style.height) {
        element.style.height = `${element.scrollHeight}px`;
      }
      if (this.duration) {
        element.style["transition-duration"] = this.duration;
      }
    },
    leave: function (element) {
      // Need to call requestAnimationFrame twice
      // to make sure collapsing will be animated
      // on the next screen repaint
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = "0px";
        });
      });
    },

    afterLeave: function (element) {
      element.style.height = null;
      if (this.duration) {
        element.style["transition-duration"] = null;
      }
      this.$emit("ui-expand-leave");
    }
  }
});
</script>
